import { createContext, useContext, useState } from "react";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [switcher, setSwitcher] = useState(null); // per-page language equivalence
  return (
    <SiteContext.Provider value={{ switcher, setSwitcher }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
